<script setup>
import { computed } from 'vue'
const props = defineProps({
  onlineMethod: {
    type: String,
    required: true
  },
  detail: {
    type: Object,
    required: true
  },
  finished: {
    type: Boolean,
    default: false,
    required: true
  }
})
// オンデマンド講習のURLを開く（外部リンク）
const openOnlineURL = (url) => {
  window.open(url, '_blank')
}
// detail.course.termの期間内かを判定、computedで管理
const isTerm = computed(() => {
  const now = new Date()
  const start = new Date(props.detail.course.term[0])
  const end = new Date(props.detail.course.term[1])
  return now >= start && now <= end
})
</script>

<template>
  <!-- 講座開催期間中は表示（終了後でも） -->
  <div
    v-if="isTerm"
    :class="finished ? 'dvd_online_container' : ''"
  >
    <template v-if="finished">
      <p class="title">
        受講済みですが再度動画を視聴できます。
      </p>
    </template>
    <template v-else>
      <template v-if="onlineMethod === 'dvd'">
        <p class="title">
          「研修動画DVD」をご利用の方は、DVDを再生してください。<br>
          視聴後、この画面に戻ってキーワードを入力してください。
        </p>
      </template>

      <template v-else-if="onlineMethod === 'online'">
        <p class="title">
          開始する場合は各動画の再⽣ボタンを押してください。<br>
          全ての動画を視聴後、この画⾯に戻ってキーワードを⼊⼒してください。
        </p>
      </template>
    </template>

    <template v-if="onlineMethod === 'online'">
      <!-- 動画URLを開くか、iframeなら埋め込みで表示 -->
      <div
        v-for="(item, index) in props.detail.course.displays.urls"
        :key="'url' + index"
      >
        <template v-if="item.html">
          <p class="iframe_title">{{ item.title }}</p>
          <div
            class="iframeContainer"
            v-html="item.html"
          />
        </template>

        <button
          v-else
          class="c-button c-button--small c-button--yellow"
          @click="openOnlineURL(item.url)"
        >
          {{ item.title }}を視聴開始<span>（別ウィンドウが開きます）</span>
        </button>
      </div>
    </template>
  </div>
</template>

<style scoped lang="scss">
.dvd_online_container {
  border: 1px solid #ddd;
  padding: 0 0 10px;
  margin: 20px auto;
}
.title {
  display: block;
  text-align: center;
  padding: 14px;
  background: #00008b;
  color: #FFF;
  font-size: 18px;
  margin: 0;
}

.iframe_title {
  display: block;
  margin: 20px 10px;
  text-align: center;
  font-size: 16px;
}

.iframeContainer {
  width: auto;
  margin: 5px auto 30px;
  text-align: center;
}

button {
  display: block;
  width: 300px;
  padding: 8px;
  margin: 20px auto 10px;
  font-size: 16px;
  text-align: center;
  height: auto !important;

  span {
    display: block;
    font-size: 13px;
  }
}
</style>
